export const modules = [
  {
    id: 'AWS_CLOUD_PRACTITIONER',
    title: 'AWS Cloud Practitioner Foundational',
    code: 'CLF-C02',
    duration: '90 minutes',
    questions: 65,
    description:
      'This exam validates your understanding of core AWS Cloud concepts, global infrastructure, pricing, support plans, and the shared responsibility model.',
    guidelines: [
      'You will have the specified time limit to complete all questions.',
      'Question formats include Multiple-choice and Multiple-response types.',
      'Each question carries equal marks; there is no negative marking.',
      'You can navigate between questions before submitting the exam.',
      'Avoid refreshing, minimizing, or closing your browser window during the test.',
      'The exam will auto-submit when the timer expires.',
      'External resources, mobile devices, or help from others are not permitted.',
      'Read each question carefully before submitting your answers.'
    ]
  },
  {
    id: 'AWS_AI_PRACTITIONER',
    title: 'AWS Certified AI Practitioner',
    code: 'AIF-C01',
    duration: '90 minutes',
    questions: 65,
    description:
      'This exam assesses your foundational understanding of Artificial Intelligence (AI), Machine Learning (ML), and AWS AI services.',
    guidelines: [
      'You will have the specified time limit to complete all questions.',
      'Question formats include Multiple-choice and Multiple-response types.',
      'Each question carries equal marks; there is no negative marking.',
      'You can navigate between questions before submitting the exam.',
      'Avoid refreshing, minimizing, or closing your browser window during the test.',
      'The exam will auto-submit when the timer expires.',
      'External resources, mobile devices, or help from others are not permitted.',
      'Read each question carefully before submitting your answers.'
    ]
  },
  {
    id: 'AZURE_DP_900',
    title: 'Microsoft Azure Fundamentals',
    code: 'AZ-900',
    duration: '45 minutes',
    questions: 65,
    description:
      'This exam validates your foundational knowledge of cloud services and how those services are provided with Microsoft Azure.',
    guidelines: [
      'You will have the specified time limit to complete all questions.',
      'Question formats include Multiple-choice and Multiple-response types.',
      'Each question carries equal marks; there is no negative marking.',
      'You can navigate between questions before submitting the exam.',
      'Avoid refreshing, minimizing, or closing your browser window during the test.',
      'The exam will auto-submit when the timer expires.',
      'External resources, mobile devices, or help from others are not permitted.',
      'Read each question carefully before submitting your answers.'
    ]
  },
  {
    id: 'AZURE_AI_900',
    title: 'Microsoft Azure AI Fundamentals',
    code: 'AI-900',
    duration: '45 minutes',
    questions: 65,
    description:
      'This exam measures your understanding of AI and machine learning workloads and Azure AI services.',
    guidelines: [
      'You will have the specified time limit to complete all questions.',
      'Question formats include Multiple-choice and Multiple-response types.',
      'Each question carries equal marks; there is no negative marking.',
      'You can navigate between questions before submitting the exam.',
      'Avoid refreshing, minimizing, or closing your browser window during the test.',
      'The exam will auto-submit when the timer expires.',
      'External resources, mobile devices, or help from others are not permitted.',
      'Read each question carefully before submitting your answers.'
    ]
  },
  {
    id: 'GOOGLE_CLOUD_DIGITAL_LEADER',
    title: 'Google Cloud Digital Leader',
    code: 'Digital Leader',
    duration: '90 minutes',
    questions: 65,
    description:
      'This exam assesses your understanding of digital transformation, cloud infrastructure, Google Cloud products, data analytics, AI, and operations.',
    guidelines: [
      'You will have the specified time limit to complete all questions.',
      'Question formats include Multiple-choice and Multiple-response types.',
      'Each question carries equal marks; there is no negative marking.',
      'You can navigate between questions before submitting the exam.',
      'Avoid refreshing, minimizing, or closing your browser window during the test.',
      'The exam will auto-submit when the timer expires.',
      'External resources, mobile devices, or help from others are not permitted.',
      'Read each question carefully before submitting your answers.'
    ]
  },
  {
    id: 'GOOGLE_AI_LEADER',
    title: 'Google Generative AI Leader',
    code: 'Gen AI Leader',
    duration: '90 minutes',
    questions: 65,
    description:
      'This exam evaluates your understanding of Generative AI concepts, Responsible AI, multimodal models, and prompt engineering on Google Cloud.',
    guidelines: [
      'You will have the specified time limit to complete all questions.',
      'Question formats include Multiple-choice and Multiple-response types.',
      'Each question carries equal marks; there is no negative marking.',
      'You can navigate between questions before submitting the exam.',
      'Avoid refreshing, minimizing, or closing your browser window during the test.',
      'The exam will auto-submit when the timer expires.',
      'External resources, mobile devices, or help from others are not permitted.',
      'Read each question carefully before submitting your answers.'
    ]
  }
];
